const MAP = {
  "In Stock": "bg-toga text-white",
  "Available for Custom Tailoring": "bg-charcoal text-cream",
  "Exclusive Archive": "bg-cream text-charcoal border border-charcoal",
};

export default function StatusBadge({ status }) {
  const cls = MAP[status] || "bg-charcoal text-cream";
  return (
    <span className={`inline-block px-3 py-1.5 text-[10px] uppercase tracking-[0.15em] font-bold ${cls}`}>
      {status}
    </span>
  );
}
